export default __webpack_public_path__ + "static/media/routting.3113749f.jpeg";